<div class="text-center">
    <span class="btn-group" *ngIf="details?.type=='btn-group'">
        <button *ngFor="let btn of details.data" value="{{btn.value}}" class="btn" [ngClass]="btn.isPrimary?'btn-primary':'btn-secondary'" (click)="btnClickInSubhead(btn.value)" [disabled]="btn.isDisabled" [hidden]="btn.hide">
                <div #element  placement="bottom" [ngbTooltip]="element.scrollWidth > element.offsetWidth+1 ? btn.text : ''">{{btn.text}}
                <img *ngIf="btn.showIcon" src="../../../../../assets/images/open-in-new-tab.svg" class="mr-2"></div></button>
    </span>
    <h3  *ngIf="details?.type=='title'">{{details.data}}</h3>
</div> 